const sectorsData = {
    "Construction": {
        "categories": [
            "Structural Materials",
            "Aggregates and Binders",
            "Forestry Materials",
            "Metals and Alloys",
            "Masonry and Bricks",
            "Decorative Stone and Surfaces",
            "Flooring and Paving",
            "Construction Chemicals and Finishes",
            "Electrical Materials",
            "Plumbing and Piping",
            "Insulation, Waterproofing and Protection",
            "Roofing Materials",
            "Glass and Glazing",
            "Hardware and Fasteners",
            "Earthwork and Excavation Materials",
            "Formwork and Temporary Structures",
            "Doors, Windows and Facade Systems",
            "Drainage and Stormwater Systems",
            "Specialty Construction Products",
            "Airport Construction Materials",
            "Airport Gates and Boarding Bridge Materials"
        ],
        "subcategories": {
            "Structural Materials": [
                "Steel Beams",
                "Reinforced Concrete",
                "Aluminum Profiles",
                "Aluminum Structures",
                "Precast Concrete Elements",
                "Timber Frames",
                "Composite Beams",
                "Structural Steel Sections"
            ],
            "Aggregates and Binders": [
                "Cement",
                "Sand",
                "Gravel",
                "Crushed Stone",
                "Lime",
                "Asphalt Binders",
                "Fly Ash",
                "Slag Cement"
            ],
            "Forestry Materials": [
                "Lumber",
                "Plywood",
                "Engineered Wood",
                "Bamboo",
                "OSB Panels",
                "Particle Board"
            ],
            "Metals and Alloys": [
                "Steel Rebars",
                "Aluminum Sheets",
                "Copper Pipes",
                "Iron Bars",
                "Stainless Steel",
                "Galvanized Steel",
                "Metal Mesh",
                "Brass Fittings",
                "Alloy Rods"
            ],
            "Masonry and Bricks": [
                "Clay Bricks",
                "Concrete Blocks",
                "Aerated Concrete Blocks",
                "Fire Bricks",
                "Natural Stone Masonry",
                "Masonry Mortar"
            ],
            "Decorative Stone and Surfaces": [
                "Marble",
                "Quartz",
                "Granite",
                "Onyx",
                "Travertine",
                "Decorative Slate Slabs",
                "Terrazzo",
                "Sintered Stone",
                "Limestone",
                "Soapstone",
                "Quartzite",
                "Engineered Marble",
                "Porcelain Slabs",
                "Stone Veneer"
            ],
            "Flooring and Paving": [
                "Ceramic Tiles",
                "Stone Tiles",
                "Decorative Tiles",
                "Concrete Pavers",
                "Paving Stones",
                "Hardwood Flooring",
                "Industrial Flooring"
            ],
            "Construction Chemicals and Finishes": [
                "Concrete Admixtures",
                "Repair Mortars",
                "Grouts",
                "Curing Compounds",
                "Epoxy Repair Systems",
                "Construction Adhesives",
                "General Purpose Sealants",
                "Paints and Coatings",
                "Plaster and Renders",
                "Varnishes",
                "Industrial Abrasives",
                "Painting Tools and Accessories",
                "Paint Brushes and Rollers",
                "Paint Trays",
                "Spray Paints",
                "Waterproof Coatings",
                "Wood Paints and Coatings",
                "Interior and Exterior Paints",
                "Sandpaper and Abrasive Sheets",
                "Masking Tapes"
            ],
            "Electrical Materials": [
                "Electrical Wires",
                "Cables",
                "Switches",
                "Circuit Breakers",
                "Conduits",
                "Lighting Fixtures",
                "Transformers",
                "Meter Bases",
                "Electrical Boxes and Enclosures",
                "Electrical Panels and Accessories",
                "Receptacles and Outlets",
                "Wall Plates",
                "Extension Cords",
                "Surge Protectors",
                "Electrical Tape",
                "Doorbells",
                "Conduit Accessories and Clamps"
            ],
            "Plumbing and Piping": [
                "PVC Pipes",
                "Copper Tubes",
                "Fittings",
                "Valves",
                "Building Drainage Pipes",
                "Sanitary Ware Components",
                "Water Heaters",
                "Gas Piping and Connections",
                "PTFE and Plumbing Tapes",
                "Plumbing Tools",
                "Pressure Tanks",
                "Water Tank Accessories",
                "Plumbing Adhesives",
                "Drain-Cleaning Tools",
                "Flexible Plumbing Connections"
            ],
            "Insulation, Waterproofing and Protection": [
                "Fiberglass Insulation",
                "Foam Insulation",
                "Waterproof Membranes",
                "Waterproofing Sealants",
                "Thermal Barriers",
                "Acoustic Panels",
                "Soundproofing Materials",
                "Fireproofing Materials"
            ],
            "Roofing Materials": [
                "Asphalt Shingles",
                "Metal Roofing",
                "Clay Roof Tiles",
                "Roofing Slate",
                "Roofing Felt",
                "Gutters",
                "Flashing"
            ],
            "Glass and Glazing": [
                "Float Glass",
                "Tempered Glass",
                "Laminated Glass",
                "Insulated Glass Units",
                "Mirrors",
                "Glass Blocks"
            ],
            "Hardware and Fasteners": [
                "Nails",
                "Screws",
                "Bolts",
                "Anchors",
                "Hinges",
                "Locks",
                "Handles",
                "Padlocks",
                "Door Hardware",
                "Closet Hardware",
                "Cabinet and Furniture Hardware",
                "Door Closers",
                "Keys and Key Blanks"
            ],
            "Earthwork and Excavation Materials": [
                "Fill Dirt",
                "Topsoil",
                "Geotextiles",
                "Erosion Control Mats",
                "Retaining Wall Blocks",
                "Drainage Aggregates"
            ],
            "Formwork and Temporary Structures": [
                "Formwork Panels",
                "Shoring Systems",
                "Scaffolding",
                "Adjustable Props",
                "Temporary Platforms",
                "Safety Barriers"
            ],
            "Doors, Windows and Facade Systems": [
                "Commercial Doors",
                "Window Systems",
                "Curtain Walls",
                "Storefront Systems",
                "Louvers",
                "Skylights",
                "Facade Anchors",
                "Roller Shutters and Metal Security Doors"
            ],
            "Drainage and Stormwater Systems": [
                "Drainage Channels",
                "Catch Basins",
                "Culverts",
                "Stormwater Tanks",
                "Trench Drains",
                "Rainwater Management Systems"
            ],
            "Specialty Construction Products": [
                "Sustainable Materials",
                "Recycled Aggregates",
                "Smart Building Components",
                "Anti-Vibration Materials",
                "Expansion Joint Systems",
                "Drywall and Gypsum Board",
                "Masonry Hand Tools",
                "Wire Mesh and Construction Wire",
                "Wheelbarrows and Site Carts",
                "Utility Ropes and Hoses",
                "Rebar Bending Tools"
            ],
            "Airport Construction Materials": [
                "Runway Asphalt Binders",
                "Airfield Cement and Concrete Inputs",
                "Runway Aggregates",
                "Airfield Geotextiles",
                "Runway Reinforcement Materials",
                "Airfield Sealants and Joint Materials",
                "Airport Drainage Materials"
            ],
            "Airport Gates and Boarding Bridge Materials": [
                "Structural Steel Profiles for Airport Gates",
                "Aluminum Profiles for Boarding Bridges",
                "Galvanized Steel Sheets for Boarding Bridges",
                "Glass and Polycarbonate Panels for Boarding Bridges",
                "Rubber Seals and Flexible Canopy Materials",
                "Anti-Slip Flooring Materials for Boarding Bridges",
                "Weather-Resistant Cladding Materials",
                "Copper Conductors and Cable Materials for Airport Gates"
            ]
        }
    },
        "Agricultural": {
            "categories": [
                "Fertilizers and Nutrients",
                "Seeds and Planting Materials",
                "Crop Protection and Pest Management",
                "Animal Feed Ingredients",
                "Soil and Growing Media",
                "Agricultural Inputs",
                "Agricultural Machinery",
                "Irrigation and Water Management",
                "Greenhouse and Protected Agriculture",
                "Post-Harvest and Storage",
                "Biological and Organic Inputs",
                "Precision Agriculture",
                "Processed Crop Products",
                "Fruits and Vegetables",
                "Oilseeds and Oils",
                "Grains and Cereals",
                "Fibers and Textiles",
                "Nuts and Spices",
                "Forestry Products"
            ],
            "subcategories": {
                "Fertilizers and Nutrients": [
                    "Nitrogen Fertilizers",
                    "Phosphate Fertilizers",
                    "Potash Fertilizers",
                    "Organic Compost",
                    "Trace Elements",
                    "Liquid Fertilizers",
                    "Slow-Release Fertilizers",
                    "Foliar Nutrients"
                ],
                "Seeds and Planting Materials": [
                    "Corn Seeds",
                    "Wheat Seeds",
                    "Rice Seeds",
                    "Sugarcane Cuttings",
                    "Vegetable Seeds",
                    "Coffee Seeds",
                    "Soybean Seeds",
                    "Sunflower Seeds",
                    "Cotton Seeds",
                    "Pasture Seeds",
                    "Flower Seeds",
                    "Hybrid Seeds",
                    "Organic Seeds",
                    "Seedlings",
                    "Bulbs and Tubers",
                    "Rootstock"
                ],
                "Crop Protection and Pest Management": [
                    "Insecticides",
                    "Fungicides",
                    "Herbicides",
                    "Rodenticides",
                    "Nematicides",
                    "Biopesticides",
                    "Netting and Covers",
                    "Mulches",
                    "Growth Regulators",
                    "Soil Fumigants",
                    "Integrated Pest Management Tools",
                    "Garden Pest-Control Equipment"
                ],
                "Animal Feed Ingredients": [
                    "Corn Meal",
                    "Soybean Meal",
                    "Wheat Bran",
                    "Molasses",
                    "Fish Meal",
                    "Alfalfa Hay",
                    "Hay",
                    "Straw",
                    "Vitamin Supplements",
                    "Mineral Mixes"
                ],
                "Soil and Growing Media": [
                    "Peat Moss",
                    "Vermiculite",
                    "Perlite",
                    "Coconut Coir",
                    "Composted Manure",
                    "Sand Mixtures",
                    "Hydroponic Substrates"
                ],
                "Agricultural Inputs": [
                    "Seedling Trays",
                    "Plant Supports",
                    "Agricultural Twine",
                    "Soil Test Kits",
                    "pH Regulators",
                    "Crop Markers",
                    "Field Fencing",
                    "Harvesting Bags"
                ],
                "Agricultural Machinery": [
                    "Agricultural Tools",
                    "Tractors",
                    "Harvesters",
                    "Plows",
                    "Sprayers",
                    "Seed Drills",
                    "Cultivators",
                    "Farm Machinery Parts",
                    "Garden Hand Tools",
                    "Lawn and Garden Power Equipment",
                    "Pruning and Cutting Tools",
                    "Landscaping Tools"
                ],
                "Irrigation and Water Management": [
                    "Drip Lines",
                    "Irrigation Pipes",
                    "Emitters",
                    "Irrigation Filters",
                    "Fertigation Systems",
                    "Agricultural Water Tanks",
                    "Water Pumps",
                    "Irrigation Controllers",
                    "Garden Hoses and Sprinklers"
                ],
                "Greenhouse and Protected Agriculture": [
                    "Greenhouse Films",
                    "Shade Nets",
                    "Growing Benches",
                    "Climate Controls",
                    "Tunnel Structures",
                    "Greenhouse Frames",
                    "Ventilation Systems"
                ],
                "Post-Harvest and Storage": [
                    "Grain Dryers",
                    "Storage Silos",
                    "Cold Storage Supplies",
                    "Produce Crates",
                    "Moisture Control",
                    "Sorting Equipment",
                    "Agricultural Packaging Supplies"
                ],
                "Biological and Organic Inputs": [
                    "Biofertilizers",
                    "Biostimulants",
                    "Microbial Inoculants",
                    "Mycorrhizae",
                    "Biological Pest Control",
                    "Organic Soil Amendments"
                ],
                "Precision Agriculture": [
                    "Soil Sensors",
                    "Weather Stations",
                    "GPS Guidance Systems",
                    "Agricultural Drones",
                    "Remote Crop Monitoring",
                    "Variable Rate Controllers"
                ],
                "Processed Crop Products": [
                    "Wheat Flour",
                    "Canned Fruits",
                    "Dried Vegetables",
                    "Refined Sugar",
                    "Fruit Concentrates",
                    "Milled Grains"
                ],
                "Fruits and Vegetables": [
                    "Fresh Fruits",
                    "Dried Fruits",
                    "Frozen Vegetables",
                    "Root Vegetables",
                    "Leafy Greens",
                    "Citrus Fruits"
                ],
                "Oilseeds and Oils": [
                    "Soybean Oil",
                    "Palm Oil",
                    "Sunflower Oil",
                    "Canola Oil",
                    "Olive Oil",
                    "Essential Oils"
                ],
                "Grains and Cereals": [
                    "Wheat",
                    "Corn",
                    "Rice",
                    "Barley",
                    "Oats",
                    "Millet"
                ],
                "Fibers and Textiles": [
                    "Cotton Fiber",
                    "Jute",
                    "Hemp",
                    "Flax",
                    "Sisal",
                    "Natural Textile Fibers",
                    "Synthetic Textile Fibers",
                    "Textile Yarns",
                    "Sewing Threads",
                    "Blanket and Knitting Yarns",
                    "Unfinished Textile Fabrics",
                    "Textile Fillings and Batting"
                ],
                "Nuts and Spices": [
                    "Almonds",
                    "Cashews",
                    "Pepper",
                    "Cinnamon",
                    "Cloves",
                    "Nutmeg"
                ],
                "Forestry Products": [
                    "Timber Logs",
                    "Wood Pulp",
                    "Bamboo",
                    "Resins",
                    "Essential Woods"
                ]
            }
        },
        "Livestock and By-Products": {
            "categories": [
                "Live Animals",
                "Animal Feed",
                "Dairy Products",
                "Meat and Poultry",
                "Animal By-Products, Hides and Fibers",
                "Animal Health and Veterinary Supplies",
                "Livestock Equipment and Housing",
                "Eggs and Poultry Products",
                "Beekeeping",
                "Aquaculture",
                "Farm Products"
            ],
            "subcategories": {
                "Live Animals": [
                    "Cattle",
                    "Poultry (Chickens)",
                    "Goats",
                    "Sheep",
                    "Pigs",
                    "Rabbits",
                    "Horses"
                ],
                "Animal Feed": [
                    "Concentrates",
                    "Forage",
                    "Supplements",
                    "Silage",
                    "Poultry Feed",
                    "Cattle Feed",
                    "Mineral Blocks"
                ],
                "Dairy Products": [
                    "Milk Powder",
                    "Cheese Bases",
                    "Butter Fat",
                    "Whey Protein",
                    "Raw Milk",
                    "Cream",
                    "Dairy Cultures"
                ],
                "Meat and Poultry": [
                    "Beef Cuts",
                    "Chicken Parts",
                    "Pork",
                    "Lamb",
                    "Processed Meat",
                    "Frozen Poultry"
                ],
                "Animal By-Products, Hides and Fibers": [
                    "Animal Hides",
                    "Bones and Horns",
                    "Wool",
                    "Gelatin Raw Materials",
                    "Leather Hides",
                    "Tallow",
                    "Feathers",
                    "Blood Meal"
                ],
                "Animal Health and Veterinary Supplies": [
                    "Veterinary Vaccines",
                    "Antiparasitics",
                    "Veterinary Antibiotics",
                    "Animal Disinfectants",
                    "Diagnostic Tests",
                    "Veterinary Instruments",
                    "Wound Care Supplies"
                ],
                "Livestock Equipment and Housing": [
                    "Feeders",
                    "Drinkers",
                    "Pens and Gates",
                    "Milking Equipment",
                    "Barn Ventilation",
                    "Animal Transport Cages",
                    "Livestock Scales"
                ],
                "Eggs and Poultry Products": [
                    "Table Eggs",
                    "Hatching Eggs",
                    "Egg Powder",
                    "Liquid Egg Products",
                    "Poultry By-Products"
                ],
                "Beekeeping": [
                    "Beehives",
                    "Honey",
                    "Beeswax",
                    "Bee Feed",
                    "Beekeeping Protective Equipment",
                    "Honey Extraction Equipment"
                ],
                "Aquaculture": [
                    "Live Fish and Fingerlings",
                    "Shrimp and Crustaceans",
                    "Aquaculture Feed",
                    "Aeration Systems",
                    "Nets and Cages",
                    "Aquaculture Pumps",
                    "Tanks and Pond Liners",
                    "Water Quality Testing"
                ],
                "Farm Products": [
                    "Chicken Coops and Poultry Houses",
                    "Barns and Stables",
                    "Livestock Shelters and Sheds",
                    "Pig Pens and Hog Houses",
                    "Rabbit Hutches",
                    "Corrals and Livestock Fencing",
                    "Egg Incubators and Hatchery Equipment",
                    "Livestock Handling Chutes",
                    "Farm Construction Kits",
                    "Silos and Feed Storage",
                    "Automatic Feeding Systems",
                    "Farm Water Troughs and Tanks"
                ]
            }
        },
        "Chemicals": {
            "categories": [
                "Acids, Bases and Caustic Soda",
                "Industrial Gases",
                "Solvents and Alcohols",
                "Petrochemicals",
                "Energy",
                "Household Chemicals",
                "Industrial and Inorganic Chemicals",
                "Pharmaceutical Ingredients",
                "Plastics",
                "Organic Chemicals",
                "Specialty Chemicals",
                "Fine Chemicals",
                "Dyes and Pigments",
                "Surfactants",
                "Catalysts",
                "Adhesives and Sealants",
                "Lubricants",
                "Water Treatment Chemicals",
                "Rubber Chemicals",
                "Food and Beverage Ingredients",
                "Cosmetic and Personal Care Ingredients",
                "Coatings, Inks and Printing Chemicals",
                "Mining and Mineral Processing Chemicals",
                "Textile, Leather and Paper Chemicals",
                "Electronic and Semiconductor Chemicals"
            ],
            "subcategories": {
                "Acids, Bases and Caustic Soda": [
                    "Sulfuric Acid",
                    "Hydrochloric Acid",
                    "Nitric Acid",
                    "Acetic Acid",
                    "Phosphoric Acid",
                    "Ammonia",
                    "Potassium Hydroxide",
                    "Sodium Hydroxide Flakes",
                    "Sodium Hydroxide Pearls",
                    "Sodium Hydroxide Liquid Solution",
                    "Food-Grade Caustic Soda",
                    "Industrial-Grade Caustic Soda"
                ],
                "Industrial Gases": [
                    "Nitrogen",
                    "Oxygen",
                    "Hydrogen",
                    "Carbon Dioxide",
                    "Argon",
                    "Helium",
                    "Acetylene",
                    "Propane"
                ],
                "Solvents and Alcohols": [
                    "Ethanol",
                    "Methanol",
                    "Acetone",
                    "Toluene",
                    "Isopropanol",
                    "Ethyl Acetate",
                    "Xylene",
                    "Butanol",
                    "Paint Thinners"
                ],
                "Petrochemicals": [
                    "Ethylene",
                    "Propylene",
                    "Benzene",
                    "Styrene",
                    "Butadiene",
                    "Cumene",
                    "Phenol"
                ],
                "Energy": [
                    "Crude Oil",
                    "Natural Gas",
                    "Coal",
                    "Biofuels",
                    "Kerosene",
                    "Diesel Fuel",
                    "Gasoline",
                    "Liquefied Petroleum Gas"
                ],
                "Household Chemicals": [
                    "Bleach",
                    "Ammonia Solution",
                    "Baking Soda",
                    "Vinegar",
                    "Dish Soap",
                    "Laundry Detergents",
                    "Glass Cleaners",
                    "Drain Cleaners",
                    "Household Disinfectants",
                    "General Detergents"
                ],
                "Industrial and Inorganic Chemicals": [
                    "Chlorine",
                    "Sodium Chloride",
                    "Calcium Carbonate",
                    "Titanium Dioxide",
                    "Alumina",
                    "Silica",
                    "Zinc Oxide",
                    "Iron Oxide",
                    "Halides",
                    "Sulfates",
                    "Nitrates",
                    "Phosphates",
                    "Silicates"
                ],
                "Pharmaceutical Ingredients": [
                    "Analgesic APIs",
                    "Antibiotic APIs",
                    "Vitamin APIs",
                    "Hormone APIs",
                    "Antiviral APIs",
                    "Oncology APIs",
                    "Excipients",
                    "Intermediates",
                    "Solvents for Pharma",
                    "Pharmaceutical Preservatives",
                    "Stabilizers",
                    "Binders",
                    "Coatings",
                    "Buffers"
                ],
                "Plastics": [
                    "Polyethylene",
                    "Polypropylene",
                    "PVC",
                    "PET",
                    "Polystyrene",
                    "ABS",
                    "Nylon",
                    "Polycarbonate",
                    "Filamento PLA",
                    "Filamento PETG",
                    "Filamento ABS",
                    "Filamento TPU"
                ],
                "Organic Chemicals": [
                    "Alkanes",
                    "Alkenes",
                    "Alkynes",
                    "Aromatics",
                    "Alcohols",
                    "Aldehydes",
                    "Ketones",
                    "Carboxylic Acids"
                ],
                "Specialty Chemicals": [
                    "Flame Retardants",
                    "Chelating Agents",
                    "UV Stabilizers",
                    "Foaming Agents",
                    "Fertilizer Additives",
                    "Industrial Waxes"
                ],
                "Fine Chemicals": [
                    "Reagents",
                    "Catalysts for Lab",
                    "High-Purity Solvents",
                    "Intermediates for Synthesis",
                    "Custom Chemicals"
                ],
                "Dyes and Pigments": [
                    "Azo Dyes",
                    "Reactive Dyes",
                    "Pigment Blue",
                    "Pigment Red",
                    "Organic Pigments",
                    "Inorganic Pigments",
                    "Disperse Dyes"
                ],
                "Surfactants": [
                    "Anionic Surfactants",
                    "Cationic Surfactants",
                    "Nonionic Surfactants",
                    "Amphoteric Surfactants",
                    "Sodium Lauryl Sulfate",
                    "Tween",
                    "Span"
                ],
                "Catalysts": [
                    "Heterogeneous Catalysts",
                    "Homogeneous Catalysts",
                    "Enzyme Catalysts",
                    "Zeolites",
                    "Platinum Catalysts",
                    "Nickel Catalysts"
                ],
                "Adhesives and Sealants": [
                    "Epoxy Adhesives",
                    "Polyurethane Sealants",
                    "Silicone Sealants",
                    "Acrylic Adhesives",
                    "Hot Melt Adhesives",
                    "Cyanoacrylate",
                    "Industrial Resins"
                ],
                "Lubricants": [
                    "Mineral Oils",
                    "Synthetic Lubricants",
                    "Greases",
                    "Hydraulic Fluids",
                    "Gear Oils",
                    "Compressor Oils",
                    "Antifreeze and Coolants"
                ],
                "Water Treatment Chemicals": [
                    "Coagulants",
                    "Flocculants",
                    "Disinfectants",
                    "pH Adjusters",
                    "Scale Inhibitors",
                    "Corrosion Inhibitors",
                    "Biocides",
                    "Activated Carbon",
                    "Ion Exchange Resins",
                    "Defoamers",
                    "Oxygen Scavengers",
                    "Membrane Cleaners"
                ],
                "Rubber Chemicals": [
                    "Accelerators",
                    "Rubber Antioxidants",
                    "Vulcanizing Agents",
                    "Fillers",
                    "Plasticizers",
                    "Processing Aids"
                ],
                "Food and Beverage Ingredients": [
                    "Preservatives",
                    "Sweeteners",
                    "Emulsifiers",
                    "Food Colorants",
                    "Acidity Regulators",
                    "Flavoring Agents",
                    "Food-Grade Stabilizers"
                ],
                "Cosmetic and Personal Care Ingredients": [
                    "Fragrances",
                    "Emollients",
                    "Humectants",
                    "Cosmetic Preservatives",
                    "UV Filters",
                    "Conditioning Agents",
                    "Personal Care Surfactants"
                ],
                "Coatings, Inks and Printing Chemicals": [
                    "Printing Inks",
                    "Solvent-Based Coatings",
                    "Water-Based Coatings",
                    "Powder Coatings",
                    "Ink Additives",
                    "Printing Solvents",
                    "Coating Resins"
                ],
                "Mining and Mineral Processing Chemicals": [
                    "Flotation Reagents",
                    "Collectors",
                    "Frothers",
                    "Leaching Agents",
                    "Dust Suppressants",
                    "Ore Processing Flocculants"
                ],
                "Textile, Leather and Paper Chemicals": [
                    "Tanning Agents",
                    "Textile Auxiliaries",
                    "Bleaching Agents",
                    "Sizing Chemicals",
                    "Paper Additives",
                    "Dye Fixing Agents"
                ],
                "Electronic and Semiconductor Chemicals": [
                    "Photoresists",
                    "Etchants",
                    "Ultra-Pure Solvents",
                    "Wafer Cleaning Chemicals",
                    "Electronic-Grade Acids",
                    "Semiconductor Process Gases"
                ]
            }
        },
        "Housing": {
            "categories": [
                "Decoration",
                "Furniture Components",
                "Kitchen and Bathroom Fixtures",
                "Heating, Cooling and Ventilation",
                "Residential Safety and Security",
                "Smart Home Components",
                "Water Storage and Sanitation",
                "Modular and Prefabricated Components",
                "Residential Lighting and Electrical Fixtures",
                "Outdoor Living and Fencing",
                "Accessibility and Mobility"
            ],
            "subcategories": {
                "Water Storage and Sanitation": [
                    "Residential Water Tanks",
                    "Septic Systems",
                    "Rainwater Collection Barrels",
                    "Household Water Filtration",
                    "Composting Toilets",
                    "Greywater Systems"
                ],
                "Modular and Prefabricated Components": [
                    "Prefabricated Room Modules",
                    "Modular Bathrooms",
                    "Container Home Modules",
                    "Prefabricated Kitchen Units",
                    "Residential Pod Systems",
                    "Modular Stair Units"
                ],
                "Residential Lighting and Electrical Fixtures": [
                    "Ceiling Lights",
                    "Pendant Lights",
                    "Wall Sconces",
                    "Floor and Table Lamps",
                    "Smart Bulbs",
                    "Under-Cabinet Lighting",
                    "Residential Lighting Controls",
                    "Standard Light Bulbs",
                    "Emergency Lighting",
                    "Outdoor Lighting",
                    "Flashlights and Portable Lighting",
                    "Lamp Holders and Sockets",
                    "Motion-Sensor Lighting"
                ],
                "Outdoor Living and Fencing": [
                    "Pergolas",
                    "Residential Fencing",
                    "Garden Gates",
                    "Patio Structures",
                    "Outdoor Privacy Screens",
                    "Raised Garden Beds",
                    "Planters and Garden Containers"
                ],
                "Accessibility and Mobility": [
                    "Residential Ramps",
                    "Grab Bars",
                    "Bathroom Safety Seats",
                    "Stair Lifts",
                    "Threshold Ramps",
                    "Tactile Home Indicators",
                    "Mobility Support Rails"
                ],
                "Decoration": [
                    "Curtain Rods",
                    "Blinds and Shades",
                    "Decorative Mirrors",
                    "Wall Art Frames",
                    "Rugs and Carpets",
                    "Home Textiles",
                    "Decorative Accessories",
                    "Window Treatments"
                ],
                "Furniture Components": [
                    "Wooden Legs",
                    "Metal Frames",
                    "Upholstery Fabrics",
                    "Foam Cushions",
                    "Drawer Slides",
                    "Cabinet Hinges"
                ],
                "Kitchen and Bathroom Fixtures": [
                    "Sinks",
                    "Faucets",
                    "Kitchen Cabinets",
                    "Finished Countertops",
                    "Shower Heads",
                    "Bathtubs",
                    "Toilets",
                    "Vanities",
                    "Shower Enclosures",
                    "Kitchen Hardware"
                ],
                "Heating, Cooling and Ventilation": [
                    "Residential Radiators",
                    "Split Air Conditioners",
                    "Portable Air Conditioners",
                    "Heat Pumps",
                    "Thermostats",
                    "Ventilation Fans",
                    "Bathroom Exhaust Fans"
                ],
                "Residential Safety and Security": [
                    "Smoke Detectors",
                    "Fire Extinguishers",
                    "Residential Alarm Systems",
                    "Security Cameras",
                    "Video Doorbells",
                    "Motion Sensors",
                    "Home Safes"
                ],
                "Smart Home Components": [
                    "Smart Locks",
                    "Thermostat Sensors",
                    "Lighting Controls",
                    "Smart Plugs",
                    "Smart Home Sensors",
                    "Automation Hubs",
                    "Voice Control Devices"
                ]
            }
        },
        "Equipment": {
            "categories": [
                "Metals and Alloys",
                "Plastics and Polymers",
                "Electronic Components",
                "Machinery Parts",
                "Spring Manufacturing Materials",
                "Rubber and Composites",
                "Hand and Power Tools",
                "Heavy Machinery",
                "Packaging Materials",
                "Material Handling and Conveyors",
                "Safety Equipment",
                "Measurement and Testing",
                "Lifting and Rigging",
                "Pumps and Valves",
                "Welding and Cutting",
                "Compressors and Pneumatics",
                "Generators and Power Systems",
                "Automation Components",
                "Electric Motors and Power Transmission",
                "Machine Tools and CNC",
                "Industrial Heating and Cooling",
                "Storage and Warehousing",
                "Maintenance and Spare Parts",
                "Industrial Cleaning Equipment"
            ],
            "subcategories": {
                "Metals and Alloys": [
                    "Steel Plates",
                    "Aluminum Ingots",
                    "Copper Rods",
                    "Stainless Steel",
                    "Brass Alloys",
                    "Titanium Bars",
                    "Nickel Alloys",
                    "Zinc Sheets"
                ],
                "Plastics and Polymers": [
                    "Polypropylene",
                    "PVC Resins",
                    "ABS Plastics",
                    "PET Granules",
                    "Polyethylene",
                    "Polystyrene",
                    "Nylon",
                    "Acrylic Sheets"
                ],
                "Electronic Components": [
                    "Circuit Boards Raw",
                    "Semiconductors Materials",
                    "LED Chips",
                    "Capacitors Bases",
                    "Resistors",
                    "Transistors",
                    "Connectors",
                    "Printed Circuit Boards"
                ],
                "Machinery Parts": [
                    "Bearings Steel",
                    "Gears Alloys",
                    "Hydraulic Fluids",
                    "Belts Rubber",
                    "Shafts",
                    "Pulleys",
                    "Couplings",
                    "Seals and Gaskets"
                ],
                "Spring Manufacturing Materials": [
                    "Spring Steel Wire",
                    "Spring Steel Strip",
                    "Spring Steel Rods",
                    "Stainless Spring Steel",
                    "Alloy Spring Steel",
                    "Non-Ferrous Spring Alloys"
                ],
                "Rubber and Composites": [
                    "Natural Rubber",
                    "Synthetic Rubber",
                    "Carbon Fiber",
                    "Fiberglass",
                    "Epoxy Resins",
                    "Kevlar",
                    "Rubber Sheets",
                    "Composite Panels"
                ],
                "Hand and Power Tools": [
                    "Pliers",
                    "Cutters",
                    "Files",
                    "Chisels",
                    "Measuring Tapes",
                    "Levels",
                    "Utility Knives",
                    "Wrenches",
                    "Screwdrivers",
                    "Hammers",
                    "Clamps",
                    "Electric Drills",
                    "Angle Grinders",
                    "Circular Saws",
                    "Impact Wrenches",
                    "Sanders",
                    "Routers",
                    "Jigsaws",
                    "Drill Bits",
                    "Abrasive Discs",
                    "Wire and Abrasive Brushes",
                    "Grinding Stones",
                    "Masonry Tools",
                    "Long-Handle Tools",
                    "Hand Saws and Hacksaws",
                    "Woodworking Planes",
                    "Staplers and Nailers",
                    "Tile Cutters",
                    "Riveters",
                    "Tool Sets",
                    "Sockets and Ratchets",
                    "Hole Saws"
                ],
                "Heavy Machinery": [
                    "Excavators",
                    "Tractors",
                    "Bulldozers",
                    "Cranes",
                    "Forklifts",
                    "Loaders",
                    "Compactors",
                    "Drilling Rigs"
                ],
                "Packaging Materials": [
                    "FIBC and Big Bags",
                    "Pallets",
                    "Stretch Wrap",
                    "Shrink Film",
                    "Protective Film",
                    "Food-Grade Film",
                    "Strapping Materials",
                    "Cardboard Boxes",
                    "Drums and Barrels"
                ],
                "Safety Equipment": [
                    "Hard Hats",
                    "Bump Caps",
                    "Ventilated Helmets",
                    "High-Visibility Helmets",
                    "Electrical Insulation Helmets",
                    "Mining Helmets",
                    "Safety Gloves",
                    "Protective Eyewear",
                    "Ear Protection",
                    "Respirators",
                    "Safety Boots",
                    "Harness Systems",
                    "First Aid Kits",
                    "Welding Masks",
                    "High-Visibility Vests",
                    "Protective Rainwear",
                    "Safety Signs",
                    "Traffic and Safety Barriers",
                    "Barrier and Warning Tape",
                    "Knee and Elbow Protection",
                    "Disposable Biosecurity Equipment",
                    "Face Shields"
                ],
                "Measurement and Testing": [
                    "Calipers",
                    "Micrometers",
                    "Multimeters",
                    "Thermometers",
                    "Pressure Gauges",
                    "Oscilloscopes",
                    "Hardness Testers"
                ],
                "Lifting and Rigging": [
                    "Hoists",
                    "Slings",
                    "Shackles",
                    "Winches",
                    "Chain Blocks",
                    "Lifting Beams",
                    "Tackle Systems"
                ],
                "Pumps and Valves": [
                    "Centrifugal Pumps",
                    "Diaphragm Pumps",
                    "Gate Valves",
                    "Ball Valves",
                    "Check Valves",
                    "Solenoid Valves",
                    "Pump Motors"
                ],
                "Material Handling and Conveyors": [
                    "Belt Conveyors",
                    "Roller Conveyors",
                    "Screw Conveyors",
                    "Pallet Jacks",
                    "Hand Trucks",
                    "Stackers",
                    "Automated Guided Vehicles",
                    "Handling Trolleys",
                    "Conveyor Belts"
                ],
                "Welding and Cutting": [
                    "Welding Electrodes",
                    "MIG Welders",
                    "TIG Welders",
                    "Plasma Cutters",
                    "Oxy-Acetylene Torches",
                    "Filler Metals",
                    "Welding Accessories and Spare Parts",
                    "Arc and Stick Welders",
                    "Welding Torches",
                    "Regulators and Welding Hoses",
                    "Gas Welding Equipment",
                    "Welding Clamps and Holders",
                    "Welding PPE Kits"
                ],
                "Compressors and Pneumatics": [
                    "Air Compressors",
                    "Pneumatic Cylinders",
                    "Air Hoses",
                    "Filters and Regulators",
                    "Pneumatic Tools",
                    "Vacuum Pumps"
                ],
                "Generators and Power Systems": [
                    "Diesel Generators",
                    "Gasoline Generators",
                    "Portable Generators",
                    "Standby Generators",
                    "Inverters",
                    "Battery Packs",
                    "Solar Panels for Equipment",
                    "Power Distribution Units"
                ],
                "Automation Components": [
                    "PLCs",
                    "Sensors",
                    "Actuators",
                    "Relays",
                    "Control Panels",
                    "Robotic Arms Components",
                    "HMI Screens",
                    "Industrial Networks",
                    "Machine Vision",
                    "Safety Controllers",
                    "Door and Gate Automation",
                    "Access Control Systems",
                    "Motor Controls and Accessories",
                    "Automation Spare Parts",
                    "Garage and Industrial Door Operators"
                ],
                "Electric Motors and Power Transmission": [
                    "AC Electric Motors",
                    "DC Electric Motors",
                    "Servo Motors",
                    "Gearboxes",
                    "Industrial Chains",
                    "Sprockets",
                    "Power Transmission Belts",
                    "Variable Frequency Drives"
                ],
                "Machine Tools and CNC": [
                    "Industrial Lathes",
                    "Milling Machines",
                    "CNC Routers",
                    "Machining Centers",
                    "Industrial Presses",
                    "Metal Cutting Machines",
                    "Tool Holders"
                ],
                "Industrial Heating and Cooling": [
                    "Industrial Boilers",
                    "Chillers",
                    "Heat Exchangers",
                    "Cooling Towers",
                    "Industrial Burners",
                    "Process Heaters",
                    "Industrial Refrigeration Units"
                ],
                "Storage and Warehousing": [
                    "Industrial Racks",
                    "Shelving Systems",
                    "Storage Bins",
                    "Warehouse Mezzanines",
                    "Dock Equipment",
                    "Workbenches",
                    "Industrial Ladders",
                    "Tool Boxes and Chests",
                    "Tool Bags and Backpacks",
                    "Small Parts Organizers",
                    "Industrial Cabinets and Lockers",
                    "Tool Holders and Belts"
                ],
                "Maintenance and Spare Parts": [
                    "Industrial Filters",
                    "Lubrication Systems",
                    "Replacement Blades",
                    "Machine Guards",
                    "Maintenance Kits",
                    "Replacement Hoses",
                    "Industrial Seals"
                ],
                "Industrial Cleaning Equipment": [
                    "Pressure Washers",
                    "Floor Scrubbers",
                    "Industrial Vacuums",
                    "Steam Cleaners",
                    "Parts Washers",
                    "Industrial Sweepers",
                    "Brooms, Brushes and Dustpans",
                    "Mops and Wringers",
                    "Sponges and Scouring Pads",
                    "Janitorial Carts",
                    "Restroom Cleaning Equipment",
                    "Cleaning Buckets and Containers"
                ]
            }
        }
};

export default sectorsData;
